module.exports = __webpack_public_path__ + "img/prize-xsd-light.b137462b.png";